module.exports = __webpack_public_path__ + "461167b37339ccdae88b42c2f4264d71.svg";